import { useMemo } from 'react';
import usePopularGoals from '@api/hooks/goal/usePopularGoals';
import { emptyList } from '@constants/empty';
import uuid from '@utils/uuid';
import ManageGoals from './ManageGoals';

const getSegregateGoalGroupsData = (goals = emptyList, isFreeTrial = false) => {
  const goalGroups = [];
  let popularGoals = [];
  let filteredDataGoalGroups = [];

  goals?.forEach((item) => {
    if (item && item.name === 'Popular Topics') {
      popularGoals = item.children;
    }
    if (item.uid && item.children && item.children.length > 0) {
      if (!item.children[0].children.length) {
        goalGroups.push(item);
        return;
      }

      return item.children.forEach((goalGroup) => {
        goalGroups.push(goalGroup);
      });
    }
  });

  if (isFreeTrial) {
    // skip platform goals for free trial
    goalGroups.map((goalGroup) => {
      const childrens = goalGroup.children.filter(
        (goal) => !goal?.isPlatformGoal
      );
      filteredDataGoalGroups.push({
        ...goalGroup,
        children: childrens
      });
      return '';
    });
  } else {
    filteredDataGoalGroups = [...goalGroups];
  }
  return [filteredDataGoalGroups, goalGroups, popularGoals];
};

const getFormattedGoalGroups = (popularGoals = []) => {
  const popularGoalGroup = [
    {
      name: 'Popular goals',
      uid: uuid(),
      children: popularGoals || [],
      disable: true
    }
  ];
  const popularGoalOptions = [];
  popularGoalGroup?.forEach((goalGroup) => {
    popularGoalOptions.push({
      ...goalGroup,
      label: goalGroup.name,
      value: goalGroup.uid
    });
    goalGroup?.children?.forEach((goal) => {
      popularGoalOptions.push({
        ...goal,
        label: goal.name,
        value: goal.uid
      });
    });
  });
  return [popularGoalGroup, popularGoalOptions];
};

const ExploreGoals = ({
  isOnboarding,
  onboardingGoals,
  onGoalSelection,
  isFreeTrial
}) => {
  const [goalGroupsFilteredData] = useMemo(
    () => getSegregateGoalGroupsData(onboardingGoals, isFreeTrial),
    [onboardingGoals, isFreeTrial]
  );

  const { popularGoals } = usePopularGoals();
  // popular searches
  const [popularGoalGroup, popularGoalOptions] = useMemo(
    () => getFormattedGoalGroups(popularGoals),
    [popularGoals]
  );

  return (
    <ManageGoals
      isOnboarding={isOnboarding}
      popularGoalGroup={popularGoalGroup}
      popularGoalOptions={popularGoalOptions}
      goalGroupsData={goalGroupsFilteredData}
      onGoalSelection={onGoalSelection}
      isFreeTrial={isFreeTrial}
    />
  );
};

export default ExploreGoals;
